import React from "react";

const ContactSection = () => (
  <section className="still-got-q" aria-labelledby="contact-title">
    <div className="container">
      <h2 id="contact-title">
        Still got a <em>question</em>?
      </h2>
      <p>
        If we haven't covered yours, send a real human at 42courses an email. We
        reply to emails within 24 hours, often sooner than that.
      </p>
      <div className="btn-row">
        <a
          href="mailto:groundcontrol@42courses.com"
          className="btn btn-primary"
        >
          Email Ground Control
        </a>
        <a href="/courses" className="btn btn-secondary">
          Browse all courses
        </a>
      </div>
    </div>
  </section>
);

export default ContactSection;
